import store from './../../store'


const checkDevice = (router) => {


  router.beforeEach((to, from, next) => {

    const userAgent = navigator.userAgent.toLowerCase();
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
    if(isTablet) {
      store.commit('users/setMeRights', 'teamlead')
    }
    // if(to.path === '/loading' && isTablet && from.path != '/loading/admin') {
    //   next('/loading/admin')
    // }
    next()
  })
}

export default checkDevice;
